import { Injectable } from '@angular/core';
import { Order, OrderUpdate } from '@compumark/order-management-client';

@Injectable({
  providedIn: 'root',
})
export class ModelMapper {
  orderToUpdateOrder(order: Order, orderUpdate: OrderUpdate): OrderUpdate {
    orderUpdate.classes = order.classes;
    orderUpdate.regions = order.regions
      ?.map((region) =>
        region.limited ? region.label + ' (Limited)' : region.label,
      )
      ?.sort((a, b) => (a ?? '').localeCompare(b ?? '')) as Array<string>;
    orderUpdate.addedRegisters = order.addedRegisters?.sort((a, b) =>
      a.localeCompare(b),
    );
    orderUpdate.removedRegisters = order.removedRegisters?.sort((a, b) =>
      a.localeCompare(b),
    );
    orderUpdate.assignee = order.assignee;
    orderUpdate.goodsAndServices = order.goodsAndServices;
    orderUpdate.freeText = order.freeText;
    orderUpdate.additionalInstruction = order.additionalInstruction;
    orderUpdate.poNumber = order.poNumber;
    orderUpdate.clientReference = order.clientReference;
    orderUpdate.subClientReference = order.subClientReference;
    orderUpdate.fullTextDetails = order.fullTextDetails;
    orderUpdate.iSkip = order.iSkip;
    return orderUpdate;
  }
}
